import { apiService } from './api';
import { Language, AdminTranslationEntry, TranslationProgress } from '../types';

class LanguageService {

  // ===== Language CRUD =====

  async getAllLanguages(): Promise<Language[]> {
    const response = await apiService.get<Language[]>('/api/admin/languages');
    return response.payload || [];
  }

  async createLanguage(data: { code: string; name: string }): Promise<Language> {
    const response = await apiService.post<Language>('/api/admin/languages', data);
    return response.payload;
  }

  // ===== Toggle & Default =====

  async toggleLanguageEnabled(languageCode: string): Promise<Language> {
    const response = await apiService.patch<Language>(`/api/admin/languages/${languageCode}/toggle`);
    return response.payload;
  }

  async setDefaultLanguage(languageCode: string): Promise<Language> {
    const response = await apiService.patch<Language>(`/api/admin/languages/${languageCode}/set-default`);
    return response.payload;
  }

  // ===== Translations =====

  async getAdminTranslations(languageCode: string): Promise<AdminTranslationEntry[]> {
    const response = await apiService.get<AdminTranslationEntry[]>(`/api/admin/languages/${languageCode}/translations`);
    return response.payload || [];
  }

  async bulkSaveTranslations(languageCode: string, translations: { keyName: string; value: string }[]): Promise<number> {
    const response = await apiService.put<{ updatedCount: number }>(`/api/admin/languages/${languageCode}/translations`, { translations });
    return response.payload?.updatedCount || 0;
  }

  // ===== Progress =====

  async getTranslationProgress(): Promise<Record<string, TranslationProgress>> {
    const response = await apiService.get<Record<string, TranslationProgress>>('/api/admin/languages/progress');
    return response.payload || {};
  }
}

export const languageService = new LanguageService();
export default languageService;
